import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { UiActionExpanderModule } from '@components/ui-action-expander';
import { UiExecutionSettingsModule } from '@components/ui-execution-settings/ui-execution-settings.module';
import { UiPasswordIndicatorModule } from '@components/ui-password-indicator/ui-password-indicator.module';
import { UiPasswordTypeToggleModule } from '@components/ui-password-toggle/ui-password-toggle.module';
import { SharedModule } from '@modules/shared.module';
import { UiGridResetModule } from '@pages/generics/grid';
import { FloatingRobotModalComponent } from '@pages/robots/modal/robot-floating.modal';
import { StandardRobotModalComponent } from '@pages/robots/modal/robot-standard.modal';
import { RobotsPageComponent } from '@pages/robots/robots.page';
import { UiGridModule } from '@uipath/angular/components/ui-grid';
import { UiSuggestModule } from '@uipath/angular/components/ui-suggest';
import { UiAutofocusModule } from '@uipath/angular/directives/ui-autofocus';
import { UiContentLoaderModule } from '@uipath/angular/directives/ui-content-loader';
import { UiNgLetModule } from '@uipath/angular/directives/ui-ng-let';
import { UiSpinnerButtonModule } from '@uipath/angular/directives/ui-spinner-button';

const MODALS = [
    FloatingRobotModalComponent,
    StandardRobotModalComponent,
];

@NgModule({
    imports: [
        CommonModule,
        RouterModule,
        SharedModule,
        UiSuggestModule,
        UiGridModule,
        UiGridResetModule,
        UiPasswordTypeToggleModule,
        UiPasswordIndicatorModule,
        UiExecutionSettingsModule,
        UiActionExpanderModule,
        UiNgLetModule,
        UiAutofocusModule,
        UiSpinnerButtonModule,
        UiContentLoaderModule,
    ],
    declarations: [
        RobotsPageComponent,
        ...MODALS,
    ],
    exports: [
        RobotsPageComponent,
    ],
    entryComponents: [
        ...MODALS,
    ],
})
export class RobotModule { }
